import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
// import './LogoGallery.css'; // Optional for external styling


const imageFilenames = [
  "progressive.png",
  "WestPACInsurance.png",
  "Safeco3.webp",
  "Travelers.png",
  "AHSLogo.jpg",
  "the-hartford-logo-png-transparent.png",
  "Nationwide_Mutual_Insurance_Company_logo.svg.png",
  "pinnacle-risk-solutions-logo.jpg",
  "AMWins.png",
  "BondExchange_Logo.jpg",
  "BristolWestInsurnace.png",
  "BurnsWilcox.png",
  "CapitalInsurnaceGroup.png",
  "Geico.png",
  "CapitalPremium Financing.jpg",
  "chubb.png",
  "CNA-Surety-Stacked-JPG.jpg",
  "Colonial-General-Logo.png",
  "CRC_Group_logo_horizontal_red.png",
  "Distinguished_programs_logo_2020_Logo.jpg",
  "foremost-insurance-logo.jpg",
  "Hagerty-logo-car-love.png",
  "HiscoxLogo.png",
  "Kemper_Logo_Color_Web.jpg",
  "Liberty-Mutual-Logo.png",
  "MarkelInsurnce.png",
  "MarketScout.jpg",
  "MendotaInsurnace.jpg",
  "met-life-des-foundations-standards-logo-asset-01.png",
  "NationalGeneral.png",
  "next-logo-large_new.png",
  "personalumbrella-logo-color-notag.png",
  "philadephia-this-one.jpg",
  "pinnacol-assurance-vector-logo.png",
  "RIC Insurnace.png",
  "risk-placement-services-logo.png",
  "The_General_Logo.jpg",
  "usli.png",
  "VirtusInsurance.png",
];

/**
 * SEO metadata for ALL carrier logos
 * - alt: accessibility + SEO
 * - title: hover tooltip + semantic reinforcement
 */
const carrierImageMeta: Record<string, { alt: string; title: string }> = {
  "progressive.png": {
    alt: "xxProgressive Insurance company logo",
    title: "aaProgressive Insurance Carrier",
  },
  "WestPACInsurance.png": {
    alt: "WestPAC Insurance company logo",
    title: "WestPAC Insurance Carrier",
  },
  "Safeco3.webp": {
    alt: "Safeco Insurance company logo",
    title: "Safeco Insurance Carrier",
  },
  "Travelers.png": {
    alt: "Travelers Insurance company logo",
    title: "Travelers Insurance Carrier",
  },
  "AHSLogo.jpg": {
    alt: "AHS (American Home Shield) company logo",
    title: "AHS (American Home Shield) Provider",
  },
  "the-hartford-logo-png-transparent.png": {
    alt: "The Hartford Insurance company logo",
    title: "The Hartford Insurance Carrier",
  },
  "Nationwide_Mutual_Insurance_Company_logo.svg.png": {
    alt: "Nationwide Insurance company logo",
    title: "Nationwide Insurance Carrier",
  },
  "pinnacle-risk-solutions-logo.jpg": {
    alt: "Pinnacle Risk Solutions company logo",
    title: "Pinnacle Risk Solutions",
  },
  "AMWins.png": {
    alt: "Amwins company logo",
    title: "Amwins Wholesale Insurance",
  },
  "BondExchange_Logo.jpg": {
    alt: "BondExchange company logo",
    title: "BondExchange Surety Bonds",
  },
  "BristolWestInsurnace.png": {
    alt: "Bristol West Insurance company logo",
    title: "Bristol West Insurance Carrier",
  },
  "BurnsWilcox.png": {
    alt: "Burns & Wilcox company logo",
    title: "Burns & Wilcox Wholesale Insurance",
  },
  "CapitalInsurnaceGroup.png": {
    alt: "Capital Insurance Group company logo",
    title: "Capital Insurance Group Carrier",
  },
  "Geico.png": {
    alt: "GEICO Insurance company logo",
    title: "GEICO Insurance Carrier",
  },
  "CapitalPremium Financing.jpg": {
    alt: "Capital Premium Financing company logo",
    title: "Capital Premium Financing",
  },
  "chubb.png": {
    alt: "Chubb Insurance company logo",
    title: "Chubb Insurance Carrier",
  },
  "CNA-Surety-Stacked-JPG.jpg": {
    alt: "CNA Surety company logo",
    title: "CNA Surety",
  },
  "Colonial-General-Logo.png": {
    alt: "Colonial General company logo",
    title: "Colonial General",
  },
  "CRC_Group_logo_horizontal_red.png": {
    alt: "CRC Group company logo",
    title: "CRC Group Wholesale Insurance",
  },
  "Distinguished_programs_logo_2020_Logo.jpg": {
    alt: "Distinguished Programs company logo",
    title: "Distinguished Programs",
  },
  "foremost-insurance-logo.jpg": {
    alt: "Foremost Insurance company logo",
    title: "Foremost Insurance Carrier",
  },
  "Hagerty-logo-car-love.png": {
    alt: "Hagerty company logo",
    title: "Hagerty Specialty Auto Insurance",
  },
  "HiscoxLogo.png": {
    alt: "Hiscox company logo",
    title: "Hiscox Business Insurance",
  },
  "Kemper_Logo_Color_Web.jpg": {
    alt: "Kemper company logo",
    title: "Kemper Insurance Carrier",
  },
  "Liberty-Mutual-Logo.png": {
    alt: "Liberty Mutual company logo",
    title: "Liberty Mutual Insurance Carrier",
  },
  "MarkelInsurnce.png": {
    alt: "Markel company logo",
    title: "Markel Insurance Carrier",
  },
  "MarketScout.jpg": {
    alt: "MarketScout company logo",
    title: "MarketScout Wholesale Insurance",
  },
  "MendotaInsurnace.jpg": {
    alt: "Mendota Insurance company logo",
    title: "Mendota Insurance Carrier",
  },
  "met-life-des-foundations-standards-logo-asset-01.png": {
    alt: "MetLife company logo",
    title: "MetLife Insurance",
  },
  "NationalGeneral.png": {
    alt: "National General Insurance company logo",
    title: "National General Insurance Carrier",
  },
  "next-logo-large_new.png": {
    alt: "NEXT Insurance company logo",
    title: "NEXT Insurance Carrier",
  },
  "personalumbrella-logo-color-notag.png": {
    alt: "PersonalUmbrella.com company logo",
    title: "PersonalUmbrella.com",
  },
  "philadephia-this-one.jpg": {
    alt: "Philadelphia Insurance company logo",
    title: "Philadelphia Insurance Carrier",
  },
  "pinnacol-assurance-vector-logo.png": {
    alt: "Pinnacol Assurance company logo",
    title: "Pinnacol Assurance Workers' Compensation",
  },
  "RIC Insurnace.png": {
    alt: "RIC Insurance company logo",
    title: "RIC Insurance",
  },
  "risk-placement-services-logo.png": {
    alt: "Risk Placement Services company logo",
    title: "Risk Placement Services (RPS)",
  },
  "The_General_Logo.jpg": {
    alt: "The General Insurance company logo",
    title: "The General Insurance Carrier",
  },
  "usli.png": {
    alt: "USLI (United States Liability Insurance) company logo",
    title: "USLI - United States Liability Insurance",
  },
  "VirtusInsurance.png": {
    alt: "Virtus Insurance company logo",
    title: "Virtus Insurance",
  },
};

const InsuranceCarriersList_v01 = () => {
  return (
    <Container>
      <h2 className="text-center mb-4">Insurance Carriers</h2>
      <h4 className="text-center mb-4">
        We shop the insurance companies for you to find the best coverage and pricing to match your unique requirements.
      </h4>

      <hr />

      <Row xs={1} sm={2} md={3} lg={4} className="g-4">
        {imageFilenames.map((file, index) => {
          const meta = carrierImageMeta[file];

          // If anything is missing, fail loudly in dev (and provide a safe fallback in prod).
          const altText = meta?.alt || `${file.replace(/\.[^/.]+$/, "")} logo`;
          const titleText = meta?.title || `${file.replace(/\.[^/.]+$/, "")}`;

          return (
            <Col key={index} className="logo-card">
              <img
                src={`./insurance/images/carrierLogos/${file}`}
                alt={altText}
                title={titleText}
                loading="lazy"
                decoding="async"
                className="logo-img img-fluid carrierLogoSize"
              />
            </Col>
          );
        })}
      </Row>
    </Container>
  );
};

export default InsuranceCarriersList_v01;